import { render, staticRenderFns } from "./BoldCell.vue?vue&type=template&id=bfd35ce2&scoped=true"
import script from "./BoldCell.vue?vue&type=script&lang=js"
export * from "./BoldCell.vue?vue&type=script&lang=js"
import style0 from "./BoldCell.vue?vue&type=style&index=0&id=bfd35ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd35ce2",
  null
  
)

export default component.exports